import * as I18n from 'circe/I18n';
import { NAME as PARENT_NAME, ROUTES as PARENT_ROUTES } from '../constants';

export const NAME = `${PARENT_NAME}/CREATE`;

export const FORM_NAME = NAME;

export const ROUTES = {
  ROOT: `${PARENT_ROUTES.ROOT}/create`,
};

export const LOAD_SPECIFICATIONS = {
  PALLET: {
    code: 'PALLET',
    label: I18n.str('PALLET', 'Pallet'),
    description: '',
  },
  BOX: {
    code: 'BOX',
    label: I18n.str('BOX', 'Box'),
    description: '',
  },
  OTHER: {
    code: 'OTHER',
    label: I18n.str('OTHER', 'Other'),
    description: '',
  },
};
